import {
  isExperimentEnabled,
  trackEvent
} from 'views/assets/scripts/optimizely'

import { HEALTHY_DEALS_XSELL } from 'shared/experiments/consts/names'
import {
  CSW_ARROW_CLICK,
  CSW_PRODUCT_CLICK,
  CSW_SHOW_ALL_CLICK
} from 'shared/experiments/consts'

export default () => {
  if (!isExperimentEnabled(HEALTHY_DEALS_XSELL)) {
    return
  }

  const xSellWidgets = document.querySelectorAll(
    '[data-clientside-api-call~="fetchCrossSell"]'
  )

  xSellWidgets.forEach(xSellWidget => {
    xSellWidget.addEventListener('click', event => {
      const { target } = event
      const options = xSellWidget.getAttribute('data-clientside-call-options')
      const widgetId = JSON.parse(options)?.params?.wid

      if (target.closest('[data-clientside-hook~="slider__item"]')) {
        trackEvent(`${CSW_PRODUCT_CLICK} ${widgetId}`)
      }
      if (target.closest('[data-clientside-hook~="slider__header"] a')) {
        trackEvent(`${CSW_SHOW_ALL_CLICK} ${widgetId}`)
      }
      if (target.closest('[data-clientside-hook~="adaptable__arrows"]')) {
        trackEvent(`${CSW_ARROW_CLICK} ${widgetId}`)
      }
    })
  })
}
